import Vuetify from 'vuetify/lib'
import Vue from 'vue'
import money from 'v-money'
import VueTheMask from 'vue-the-mask'
import Vuelidate from 'vuelidate'
import App from './App.vue'
import router from './router'
import store from './store'
import VuePageTransition from 'vue-page-transition'
import GSignInButton from 'vue-google-signin-button'
import FBSignInButton from 'vue-facebook-signin-button'
import SVGInjectorVue from 'svginjector-vue'
import "./global.css"
window.$ = require('jquery')

Vue.use(SVGInjectorVue)
Vue.use(Vuelidate)
Vue.use(FBSignInButton)
Vue.use(GSignInButton)
Vue.use(VueTheMask)
Vue.use(VuePageTransition)
Vue.config.productionTip = false
Vue.use(money,{precision:4})
Vue.use(Vuetify)


const opts = {}

export default new Vuetify(opts)
new Vue({
  router,
  store,
  vuetify:new Vuetify(opts),
  render: h => h(App)
}).$mount('#app')
